import { LoaderFunctionArgs } from 'react-router';
import { productApi } from '@repo/api-client';
import { urlControlPanel, urlSales } from '@/urls';
import { Sales } from './sales';
import { getPagination } from '@repo/api-client';

export const route = {
  path: urlSales(':id'),
  element: <Sales />,
  handle: {
    title: 'Ventas',
    backLink: (params: { id: string }) => urlControlPanel(params.id),
  },
  loader: async ({ params, request }: LoaderFunctionArgs) => {
    const clubId = params.id as string;
    const { count, daySummary, results } = await productApi.getSales(
      clubId,
      getPagination(request)
    );
    const sorted = [...daySummary].sort((a, b) => a.date.localeCompare(b.date));
    const minDate =
      sorted.length > 0
        ? sorted[0].date.split('-').map(Number)
        : [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()];
    const maxDate =
      sorted.length > 0
        ? sorted[sorted.length - 1].date.split('-').map(Number)
        : [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()];
    const minDateObj = new Date(minDate[0], minDate[1] - 1, minDate[2]);
    const maxDateObj = new Date(maxDate[0], maxDate[1] - 1, maxDate[2]);
    for (let d = minDateObj; d <= maxDateObj; d.setDate(d.getDate() + 1)) {
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
        d.getDate()
      ).padStart(2, '0')}`;
      if (!daySummary.find((d) => d.date === key)) {
        daySummary.push({ date: key, amount: 0 });
      }
    }
    daySummary.sort((a, b) => a.date.localeCompare(b.date));
    return {
      clubId,
      sales: {
        count,
        daySummary,
        results,
      },
    };
  },
};
